import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

const fenceShape = {
  api: () => {
    return axiosFactory()
      .auth.get(`geofences/shapes/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const addfence = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('geofences/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const allFences = {
  api: (page) => {
    return axiosFactory()
      .auth.get(`geofences/${currentPage(page)}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const removeFence = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('geofences/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getFence = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('geofences/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editFence = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('geofences/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}


export { fenceShape, addfence, allFences, removeFence, getFence, editFence }
